module.exports = __webpack_public_path__ + "img/dsci0131.3ea12a1e.jpg";